import React from 'react';

import { TableRow, TableCell } from '@core-ui/Components/ui/table';
import { Skeleton } from '@core-ui/Components/ui/skeleton';

interface ContactsTableSkeletonProps {activeTab?: string;
  rows?: number;
}

export default function ContactsTableSkeleton ({
  rows = 8,
}: ContactsTableSkeletonProps): React.JSX.Element {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <TableRow key={`s-${i}`} className="border-b border-border/60 hover:bg-transparent">
          <TableCell className="py-3">
            <div className="flex items-center gap-3">
              <Skeleton className="h-8 w-8 rounded-full bg-muted-foreground/20" />
              <Skeleton className="h-4 w-40 rounded bg-muted-foreground/20" />
            </div>
          </TableCell>
          <TableCell className="py-3">
            <Skeleton className="h-4 w-16 rounded bg-muted-foreground/20" />
          </TableCell>
          <TableCell className="py-3">
            <div className="flex gap-2">
              <Skeleton className="h-4 w-14 rounded-full bg-muted-foreground/20" />
              <Skeleton className="h-4 w-14 rounded-full bg-muted-foreground/20" />
            </div>
          </TableCell>
          <TableCell className="py-3">
            <Skeleton className="h-4 w-40 rounded bg-muted-foreground/20" />
          </TableCell>
          <TableCell className="py-3">
            <Skeleton className="h-4 w-12 rounded bg-muted-foreground/20" />
          </TableCell>
          <TableCell className="py-3">
            <Skeleton className="h-4 w-16 rounded-full bg-muted-foreground/20" />
          </TableCell>
          <TableCell className="py-3">
            <div className="flex justify-center gap-3">
              <Skeleton className="h-4 w-12 rounded-full bg-muted-foreground/20" />
              <Skeleton className="h-4 w-12 rounded-full bg-muted-foreground/20" />
            </div>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}
